var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDtrk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#b9ddf9",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172 2530 c-70 -35 -114 -82 -148 -154 l-24 -51 0 -1046 0 -1046 30 -61 c35 -70 82 -114 154 -148 l51 -24 483 0 c265 0 482 3 482 8 0 4 -95 102 -210 217 l-210 210 -18 45 -17 45 0 755 0 755 14 39 c18 51 76 115 126 137 l40 19 353 0 353 0 37 -15 37 -16 423 -422 422 -422 0 -420 0 -420 -250 -250 c-137 -137 -250 -253 -250 -257 0 -5 62 -8 138 -8 l139 0 61 30 c70 35 114 82 148 154 l24 51 0 1045 0 1045 -24 51 c-34 72 -78 119 -148 154 l-61 30 -1047 0 -1047 0 -61 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 2091 l0 -29 16 -6 c20 -8 248 -8 268 0 l16 6 0 29 0 29 -150 0 -150 0 0 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790 1275 l0 -725 485 0 485 0 0 725 0 725 -485 0 -485 0 0 -725z m643 441 c68 -35 125 -93 163 -168 l27 -53 5 -78 5 -77 -23 -63 c-12 -34 -40 -92 -61 -128 -47 -81 -161 -229 -223 -289 l-46 -44 -46 44 c-62 60 -176 208 -223 289 -21 36 -49 94 -61 128 l-23 63 5 77 5 78 26 52 c47 92 115 154 206 189 l36 14 85 -3 85 -2 58 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211 1506 c-33 -18 -50 -53 -51 -104 0 -81 40 -122 121 -122 78 0 119 41 119 120 0 52 -18 88 -51 106 -35 17 -106 18 -138 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 471 l0 -29 16 -6 c9 -3 28 -6 44 -6 16 0 35 3 44 6 l16 6 0 29 0 29 -60 0 -60 0 0 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220 471 l0 -29 16 -6 c9 -3 28 -6 44 -6 16 0 35 3 44 6 l16 6 0 29 0 29 -60 0 -60 0 0 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 471 l0 -29 16 -6 c9 -3 28 -6 44 -6 16 0 35 3 44 6 l16 6 0 29 0 29 -60 0 -60 0 0 -29z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#2d2d2d",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M875 2221 c-50 -22 -108 -86 -126 -137 l-14 -39 0 -765 0 -765 18 -47 18 -46 48 -45 48 -45 56 -12 56 -11 333 3 334 3 49 26 50 25 31 42 32 41 11 51 11 51 0 729 0 729 -11 52 -11 52 -42 45 c-22 25 -59 53 -81 63 l-40 19 -365 0 -365 0 -40 -19z m545 -130 c0 -10 -7 -22 -16 -25 -20 -8 -228 -8 -248 0 -9 3 -16 15 -16 25 l0 19 140 0 140 0 0 -19z m330 -816 l0 -715 -475 0 -475 0 0 715 0 715 475 0 475 0 0 -715z m-720 -805 l0 -20 -25 -6 c-14 -3 -36 -3 -50 0 l-25 6 0 20 0 20 50 0 50 0 0 -20z m300 0 l0 -20 -25 -6 c-14 -3 -36 -3 -50 0 l-25 6 0 20 0 20 50 0 50 0 0 -20z m300 0 l0 -20 -25 -6 c-14 -3 -36 -3 -50 0 l-25 6 0 20 0 20 50 0 50 0 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159 1746 c-91 -35 -159 -97 -206 -189 l-27 -52 -4 -88 -4 -88 22 -62 c12 -34 40 -92 61 -128 48 -83 161 -229 228 -294 l51 -49 51 49 c67 65 180 211 228 294 21 36 49 94 61 128 l22 62 -4 88 -4 88 -28 53 c-38 75 -95 133 -163 168 l-58 29 -95 2 -95 2 -36 -13z m180 -250 c31 -17 51 -54 51 -96 0 -65 -45 -110 -109 -110 -67 0 -111 45 -111 112 1 64 44 107 108 108 18 0 45 -6 61 -14z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#b4daf8",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1185 1750 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350 1756 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055 1690 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485 1690 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225 1510 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315 1510 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167 1453 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 1451 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 1361 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387 1363 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 1321 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1626 1313 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225 1290 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315 1290 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 1214 c0 -5 7 -19 15 -30 8 -10 15 -14 15 -8 0 5 -7 19 -15 30 -8 10 -15 14 -15 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580 1200 c-6 -12 -9 -24 -7 -27 3 -2 11 5 17 17 6 12 9 24 7 27 -3 2 -11 -5 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 1121 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537 1123 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150 931 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397 933 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2122 437 c-232 -232 -422 -425 -422 -430 0 -4 80 -7 178 -7 l177 0 253 253 252 252 0 178 c0 97 -3 177 -8 177 -4 0 -197 -190 -430 -423z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#acd3f1",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2270 1640 c0 -20 164 -184 179 -179 6 2 -32 47 -84 99 l-95 95 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2179 903 l-367 -368 -6 -34 c-9 -48 -42 -98 -89 -132 -21 -16 -56 -31 -76 -35 l-36 -6 -157 -156 c-87 -86 -158 -160 -158 -164 0 -5 51 -8 113 -8 l112 0 523 523 522 522 0 113 c0 61 -3 112 -8 112 -4 0 -172 -165 -373 -367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050 145 c47 -47 87 -80 89 -74 5 15 -139 159 -159 159 l-15 0 85 -85z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#b1d6f4",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M835 2200 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705 2200 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777 2143 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125 1730 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415 1730 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935 1519 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616 1517 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 1462 c0 -14 109 -116 117 -109 4 4 -18 32 -47 62 -52 52 -70 65 -70 47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050 1061 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497 1063 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2025 530 l-530 -530 105 0 105 0 428 428 428 428 -3 102 -3 102 -530 -530z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 981 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437 983 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 431 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 72 c0 -14 69 -76 77 -69 3 4 -9 23 -27 42 -33 34 -50 43 -50 27z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#a7cdec",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2100 1809 c0 -19 55 -72 70 -67 l11 3 -41 40 -40 39 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2137 1132 l-317 -317 0 -88 c0 -48 3 -87 8 -87 4 0 169 162 367 360 l360 360 -45 45 c-24 25 -47 45 -50 45 -3 0 -148 -143 -323 -318z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777 433 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705 360 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865 330 l30 -31 4 12 c2 7 -6 21 -19 31 -36 29 -46 21 -15 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215 210 l-110 -110 48 -47 47 -48 150 150 c83 82 150 153 150 157 0 5 -39 8 -88 8 l-87 0 -110 -110z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#aacfee",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2160 1742 c0 -14 109 -116 117 -109 4 4 -18 32 -47 62 -52 52 -70 65 -70 47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2183 1007 l-361 -362 -4 -63 -4 -63 373 373 373 373 0 47 c0 26 -4 49 -8 52 -5 3 -171 -158 -369 -357z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1550 323 l-55 -4 -152 -151 c-84 -84 -150 -155 -147 -160 3 -4 26 -8 52 -8 l47 0 165 165 c91 91 160 164 155 163 -6 -1 -35 -3 -65 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 312 c0 -14 89 -96 97 -89 4 4 -13 28 -37 52 -42 43 -60 54 -60 37z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#a2c7e6",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M905 2230 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 2236 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745 2069 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745 1990 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 1740 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 1746 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2077 1312 l-257 -257 0 -83 c0 -45 3 -82 7 -82 5 0 142 134 305 297 l298 298 -42 42 c-23 24 -45 43 -48 43 -3 0 -121 -116 -263 -258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925 1479 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1626 1477 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 501 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 360 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035 270 l-49 -50 44 -45 44 -45 88 87 c48 48 88 91 88 95 0 5 -37 8 -83 8 l-83 0 -49 -50z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#9cc0df",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M825 2190 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710 2196 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785 2149 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2002 1537 l-182 -182 0 -113 c0 -61 3 -112 7 -112 5 0 115 107 245 237 l238 238 -57 57 c-32 32 -60 58 -63 58 -3 0 -87 -82 -188 -183z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975 1599 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1576 1597 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 1141 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546 1133 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120 971 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426 963 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796 463 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780 421 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905 302 l49 -52 28 27 c15 15 28 30 28 33 0 4 -26 11 -57 17 -32 6 -67 15 -78 19 l-20 7 50 -51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670 340 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#a5cae9",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M875 2220 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660 2226 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 2131 c0 -20 317 -337 327 -328 4 4 -68 83 -160 175 -92 92 -167 160 -167 153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134 2105 c-8 -20 2 -45 18 -44 l13 1 -12 5 c-19 7 -16 41 5 46 l17 5 -18 1 c-10 0 -20 -6 -23 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403 2114 c18 -6 24 -39 7 -47 -6 -3 -5 -4 2 -3 7 2 13 13 13 27 l0 24 -20 2 -20 2 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 2099 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045 1680 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495 1680 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2117 1192 l-297 -297 0 -50 0 -50 325 325 324 324 -21 23 c-12 13 -24 23 -27 23 -4 0 -140 -134 -304 -298z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 905 c7 -9 15 -13 17 -11 7 7 -7 26 -19 26 l-10 0 12 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375 909 c-11 -17 1 -21 15 -4 l12 15 -10 0 c-6 0 -14 -5 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924 485 c-8 -20 2 -45 18 -44 l13 1 -12 5 c-19 7 -16 41 5 46 l17 5 -18 1 c-10 0 -20 -6 -23 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013 494 c18 -6 24 -39 7 -47 -6 -3 -5 -4 2 -3 7 2 13 13 13 27 l0 24 -20 2 -20 2 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224 485 c-8 -20 2 -45 18 -44 l13 1 -12 5 c-19 7 -16 41 5 46 l17 5 -18 1 c-10 0 -20 -6 -23 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313 494 c18 -6 24 -39 7 -47 -6 -3 -5 -4 2 -3 7 2 13 13 13 27 l0 24 -20 2 -20 2 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524 485 c-8 -20 2 -45 18 -44 l13 1 -12 5 c-19 7 -16 41 5 46 l17 5 -18 1 c-10 0 -20 -6 -23 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 494 c18 -6 24 -39 7 -47 -6 -3 -5 -4 2 -3 7 2 13 13 13 27 l0 24 -20 2 -20 2 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 471 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 230 l-90 -90 25 -25 25 -25 115 115 115 115 -50 0 -50 0 -90 -90z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#91b4d2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1796 2100 c20 -69 24 -113 24 -337 0 -134 3 -243 8 -243 4 0 70 63 147 140 l140 140 -164 163 -163 162 8 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203 1753 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 1753 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075 1700 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 1706 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035 1670 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500 1676 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 1330 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 1330 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 1051 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486 1043 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766 413 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 369 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 370 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 344 c0 -7 52 -25 57 -20 2 2 -10 8 -26 14 -17 6 -31 9 -31 6z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#fefefe",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2423 l0 -138 24 58 c42 100 86 145 188 192 l53 24 -132 0 -133 1 0 -137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2355 2531 c34 -15 77 -43 98 -61 l37 -32 35 -72 35 -71 0 133 0 132 -132 0 -133 -1 60 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2550 258 c0 -25 -48 -115 -80 -151 l-32 -37 -72 -35 -71 -35 133 0 132 0 0 135 c0 74 -2 135 -5 135 -3 0 -5 -6 -5 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 133 l0 -133 133 0 132 0 -71 35 -72 35 -32 37 c-18 21 -46 64 -61 98 l-28 60 -1 -132z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#96bad9",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1962 1667 l-143 -143 3 -92 3 -92 188 188 187 187 -48 48 -47 47 -143 -143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 1635 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546 1635 c4 -8 11 -15 16 -15 l10 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -1 -7 2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 901 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366 893 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806 493 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786 443 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690 350 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640 330 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#a0c5e4",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M855 2210 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680 2216 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 2141 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765 2119 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2057 1372 l-237 -237 0 -50 0 -50 265 265 264 264 -21 23 c-12 13 -24 23 -27 23 -4 0 -113 -107 -244 -238z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263 1513 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162 1400 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392 1400 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 1291 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616 1283 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263 1283 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760 451 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975 290 l-29 -30 25 -25 25 -25 54 55 54 55 -50 0 -50 0 -29 -30z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#b0d2ec",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1218 2113 c34 -2 90 -2 125 0 34 2 6 3 -63 3 -69 0 -97 -1 -62 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735 1280 c0 -399 1 -562 2 -363 2 200 2 526 0 726 -1 199 -2 36 -2 -363z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277 1993 l473 -3 3 -718 2 -717 0 720 0 720 -475 0 -475 0 472 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105 1720 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 1720 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990 1619 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1555 1620 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273 1513 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205 1500 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335 1500 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177 1473 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 1471 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 1400 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 1400 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 1341 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377 1343 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205 1300 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335 1300 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273 1283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 1261 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1606 1253 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 1091 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517 1093 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 1021 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1467 1023 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 920 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385 920 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963 493 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263 493 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563 493 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#3d4145",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M943 2233 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603 2233 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893 2223 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653 2223 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844 2198 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705 2200 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 2141 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774 2128 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 2080 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 2081 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1811 2034 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 2030 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238 1753 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308 1753 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118 1724 c-38 -20 -36 -28 2 -9 17 9 30 18 30 20 0 7 -1 6 -32 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410 1736 c0 -3 14 -12 30 -21 17 -9 30 -13 30 -11 0 3 -13 12 -30 21 -16 9 -30 13 -30 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054 1678 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495 1680 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994 1618 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1555 1620 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951 1553 l-11 -28 15 19 c8 11 15 23 15 28 0 15 -7 8 -19 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1590 1574 c0 -6 7 -19 16 -30 l15 -19 -12 25 c-14 31 -19 36 -19 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214 1504 l-19 -15 25 12 c31 14 36 19 24 19 -6 0 -19 -7 -30 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311 1516 c2 -2 15 -9 29 -15 l25 -12 -19 15 c-11 9 -24 16 -30 16 -5 0 -7 -2 -5 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 1490 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 1490 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 1459 c-7 -11 -10 -23 -7 -25 2 -2 9 7 15 21 14 30 7 33 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381 1460 c14 -31 19 -36 19 -24 0 6 -7 19 -16 30 l-15 19 12 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 1430 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 1430 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 1360 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 1364 c0 -6 7 -19 16 -30 l15 -19 -12 25 c-14 31 -19 36 -19 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381 1343 l-11 -28 15 19 c8 11 15 23 15 28 0 15 -7 8 -19 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 1360 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214 1296 c11 -9 24 -16 30 -16 12 0 7 5 -24 19 l-25 12 19 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 1295 c-14 -8 -20 -14 -14 -15 5 0 19 7 30 15 24 18 16 19 -16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 1270 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 1270 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972 1195 c12 -24 23 -43 26 -41 4 5 -36 86 -43 86 -3 0 5 -20 17 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580 1199 c-12 -23 -20 -43 -18 -45 3 -2 14 17 26 41 27 56 20 60 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027 1099 c10 -17 24 -36 32 -42 8 -7 2 7 -14 31 -32 49 -45 57 -18 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515 1088 c-16 -24 -22 -38 -14 -31 15 12 53 73 46 73 -2 0 -17 -19 -32 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086 1017 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465 1019 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115 980 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434 978 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 926 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379 913 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 530 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 530 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 480 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 480 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 430 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774 428 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845 360 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704 358 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893 333 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653 333 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943 323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603 323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#748796",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M804 2168 l-19 -23 23 19 c12 11 22 21 22 23 0 8 -8 2 -26 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745 2170 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23 20 -3 0 3 -9 13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134 2108 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415 2110 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135 2070 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414 2068 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1811 2054 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173 1743 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373 1743 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064 1688 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485 1690 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984 1608 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565 1610 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921 1454 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1631 1454 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 1300 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 1300 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075 1030 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474 1028 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 1006 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449 993 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 845 c13 -14 26 -25 28 -25 3 0 -5 11 -18 25 -13 14 -26 25 -28 25 -3 0 5 -11 18 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319 843 l-24 -28 28 24 c15 14 27 26 27 28 0 8 -8 1 -31 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924 488 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025 490 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224 488 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325 490 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524 488 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625 490 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925 450 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 448 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225 450 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324 448 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1525 450 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624 448 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805 390 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23 20 -3 0 3 -9 13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744 388 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923 323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#d3e9fa",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258 2553 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2278 2553 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 2534 c-16 -8 -28 -17 -28 -20 0 -2 12 2 28 9 15 8 34 17 42 20 l15 5 -15 1 c-8 0 -27 -7 -42 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 2543 c8 -3 27 -12 43 -20 15 -7 27 -11 27 -9 0 8 -58 36 -72 35 l-13 -1 15 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 2463 l-34 -38 38 34 c34 33 42 41 34 41 -2 0 -19 -17 -38 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 2465 c19 -19 36 -35 39 -35 3 0 -10 16 -29 35 -19 19 -36 35 -39 35 -3 0 10 -16 29 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 2369 c-9 -17 -15 -34 -13 -39 2 -5 11 9 20 30 20 47 15 53 -7 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2528 2360 c9 -21 18 -35 20 -30 3 9 -25 70 -33 70 -2 0 4 -18 13 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2285 l0 -30 5 18 c2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2552 2290 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2552 275 l0 -30 5 18 c2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 270 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 232 c-1 -14 27 -72 35 -72 2 0 -2 12 -9 28 -8 15 -17 34 -20 42 l-5 15 -1 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2528 200 c-9 -22 -15 -40 -13 -40 8 0 36 61 33 70 -2 5 -11 -9 -20 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 95 c19 -19 36 -35 39 -35 3 0 -10 16 -29 35 -19 19 -36 35 -39 35 -3 0 10 -16 29 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2459 93 l-34 -38 38 34 c20 19 37 36 37 38 0 8 -8 0 -41 -34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 45 c0 -8 61 -36 70 -33 5 2 -9 11 -30 20 -22 9 -40 15 -40 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2355 29 c-22 -10 -34 -19 -27 -19 15 0 72 28 72 35 0 6 3 7 -45 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258 3 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2278 3 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#63727d",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M928 2233 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618 2233 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785 2120 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 2090 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741 2044 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218 1753 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328 1753 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 1530 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 1530 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243 1513 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303 1513 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 1500 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 1500 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189 1483 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350 1496 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 1440 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 1440 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 1430 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 1430 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 1370 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 1370 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921 1344 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1631 1344 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 1326 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359 1313 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243 1283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303 1283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025 1100 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524 1098 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045 1070 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504 1068 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 946 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399 933 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263 815 l17 -19 18 19 17 19 -17 -13 -18 -13 -17 13 -18 13 18 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741 514 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1811 514 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857 349 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933 323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618 323 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#8197a8",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1765 2150 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143 1733 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403 1733 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135 950 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414 948 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205 870 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344 868 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#525c64",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1790 2111 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964 1578 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585 1580 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 1240 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600 1240 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995 1150 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554 1148 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#e9f4fc",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204 2538 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2345 2540 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 2505 c-10 -8 -14 -14 -9 -14 6 0 19 6 29 14 11 8 15 15 10 15 -6 0 -19 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2406 2505 c10 -8 24 -14 29 -14 6 0 1 6 -9 14 -11 8 -24 15 -30 15 -5 0 -1 -7 10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 2422 c-17 -31 -13 -40 5 -14 9 13 14 26 11 29 -3 2 -10 -4 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2491 2435 c0 -5 6 -19 14 -29 8 -11 15 -15 15 -10 0 6 -7 19 -15 30 -8 10 -14 15 -14 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2348 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2535 2350 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 210 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2534 208 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 164 c0 -6 7 -19 15 -30 8 -10 14 -14 14 -9 0 6 -6 19 -14 29 -8 11 -15 15 -15 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2501 149 c-7 -12 -10 -23 -8 -26 3 -3 11 5 17 17 15 28 8 35 -9 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 55 c11 -8 24 -15 30 -15 5 0 1 7 -10 15 -10 8 -23 14 -29 14 -5 0 -1 -6 9 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2406 55 c-11 -8 -15 -15 -10 -15 6 0 19 7 30 15 10 8 15 14 9 14 -5 0 -19 -6 -29 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 20 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2344 18 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#bddef9",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288 2553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2258 2553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 2498 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415 2500 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 2418 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2495 2420 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2264 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2551 2264 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 294 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2551 294 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 140 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2494 138 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 60 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2414 58 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 3 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2258 3 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#8fa9bd",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1019 1653 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 1666 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195 880 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354 878 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#c4e2fa",
    stroke: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtrk);
export default __webpack_public_path__ + "static/media/dtrk.6682eb4980c279840b549303be9c7574.svg";
export { ForwardRef as ReactComponent };